import React, {useContext} from "react";
import Headroom from "react-headroom";
import "./Header.scss";
import StyleContext from "../../contexts/StyleContext";
import {socialMediaLinks} from "../../../portfolio";
import {
  greeting,
  workExperiences,
  skillsSection,
  openSource,
  blogSection,
  talkSection,
  achievementSection,
  resumeSection
} from "../../../portfolio";

function Header() {

  const viewResume = resumeSection.display;

  return (
    <Headroom style={{zIndex:3, backdropFilter: "blur(8px)"}}>
      <header className={"dark-menu header" }>
        <a href="/" className="logo">
          <span className="grey-color"> &lt;</span>
          <span className="logo-name">{greeting.username}</span>
          <span className="grey-color">/&gt;</span>
        </a>
        <input className="menu-btn" type="checkbox" id="menu-btn" />
        <label
          className="menu-icon"
          htmlFor="menu-btn"
          style={{color: "white"}}
        >
          <span className={"navicon navicon-dark"}></span>
        </label>
        <ul className={"dark-menu menu"}>
          <li>
            <a href={`mailto:${socialMediaLinks.gmail}`}>Contact Me</a>
          </li>
          {viewResume && (
            <li >
              <a href={require("./Arb Koci CV Resume.pdf")}><p className="special-cv">Get CV</p></a>
            </li>
          )}
          
        </ul>
        
      </header>
      <div className="str-line"></div>
    </Headroom>
  );
}
export default Header;
